<div>
  <div class="modal-header">
    <h3>Group Review</h3>
  </div>
  <div class="modal-body">
    <app-routing-review [contentType]="item.content_type" [foreignKey]="item.record_id"
                        [groupKey]="item.globalid" [expandOnLoad]="true"></app-routing-review>
  </div>
  <div class="modal-footer">
        <button class="btn btn-default" *ngIf="!saving" (click)="activeModal.close()">Close</button>
  </div>
</div>
